module.exports = __webpack_public_path__ + "static/media/Immediate Suspension Order and Proposal to Suspend - signed.dceda196.pdf";